"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var useClickOutside_1 = __importDefault(require("../../hooks/useClickOutside"));
var consts_1 = require("./consts");
var styles_1 = require("./styles");
/**
 * Tooltip component
 * @param {string} text - Tooltip text
 * @param {string} supportText - Tooltip support text
 * @param {React.ReactNode} children - Tooltip children
 * @param {number} [width] - Tooltip width, default 200px
 * @param {number} [left] - Tooltip left position, default -12px
 * @param {number} [bottom] - Tooltip bottom position, default 30px
 */
var Tooltip = function (_a) {
    var text = _a.text, children = _a.children, _b = _a.width, width = _b === void 0 ? 99 : _b, _c = _a.left, left = _c === void 0 ? -12 : _c, _d = _a.bottom, bottom = _d === void 0 ? 30 : _d;
    var _e = (0, react_1.useState)(false), open = _e[0], setOpen = _e[1];
    var containerRef = (0, react_1.useRef)(null);
    (0, useClickOutside_1.default)(containerRef, function () {
        setOpen(false);
    });
    (0, react_1.useEffect)(function () {
        if (open) {
            if (containerRef.current) {
                containerRef.current.focus();
            }
        }
    }, [open]);
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ ref: containerRef, tabIndex: -1, onClick: function () { return setOpen(!open); }, "data-testid": consts_1.TEST_ID_TOOLTIP_CONTAINER }, { children: [children, open && ((0, jsx_runtime_1.jsx)(styles_1.TooltipContainer, __assign({ style: {
                    width: width,
                    left: left,
                    bottom: bottom,
                } }, { children: (0, jsx_runtime_1.jsx)(styles_1.Text, __assign({ size: "sm" }, { children: text })) })))] })));
};
exports.default = Tooltip;
